module.exports = __webpack_public_path__ + "static/media/Stick-to-Conventions.b516b2a0.png";